<template>
  <div>

    <input
      type="email"
      v-model="billingEmail"
      placeholder="Email de cobrança"
      class="form-control"
    />

    <div class="form-control" id="card-element"></div>

    <div class="alert alert-danger" v-if="errorMessage">{{ errorMessage }}</div>

    <button @click="submit" class="btn btn-success">
      {{_lang('Save')}}
    </button>
  </div>
</template>

<script>
import axios from 'axios';
import { mapGetters, mapActions } from 'vuex';

export default {
  data () {
    return {
      stripe: null,
      stripeElements: null,
      setupIntent: null,
      card: null,
      billingEmail: null,
      errorMessage: null
    }
  },
  computed: {
    ...mapGetters({
        user: 'user'
    }),
  },
  methods: {
    ...mapActions({
      startLoading: 'startLoading',
      stopLoading: 'stopLoading'
    }),

    async getSetupIntent () {
      let { data } = await axios.get(`${process.env.VUE_APP_NODE_SERVER}/stripe-setup-intent/${this.user.id}`);
      this.setupIntent = data;
    },

    async setupStripe () {
      let { data } = await axios.get(`${process.env.VUE_APP_NODE_SERVER}/stripe-config`);
      let publicKey = data.publicKey;
      this.stripe = Stripe(publicKey, { locale: 'pt-BR' });
      this.stripeElements = this.stripe.elements();
      this.card = this.stripeElements.create('card');
      this.card.mount('#card-element');
    },

    async setDefaultMethod (methodId) {
      try {
        this.startLoading();
        await axios.post(`${process.env.VUE_APP_NODE_SERVER}/stripe-set-default-payment-method/${this.user.id}/${methodId}`);
      } catch (error) {
        console.error(error);
      } finally {
        this.stopLoading();

        window.location.reload()
      }
    },

    async submit () {
      try {
        this.startLoading();
        this.errorMessage = null;

        let result = await this.stripe.confirmCardSetup(
          this.setupIntent.client_secret,
          {
            payment_method: {
              card: this.card,
              billing_details: {
                email: this.billingEmail
              }
            }
          }
        );

        if (result.error) {
          console.error(result.error);
          this.errorMessage = result.error.message;
        } else {
          console.log('confirmCardSetup DONE', result);
          this.setDefaultMethod(result.setupIntent.payment_method);


        }

      } catch (error) {
        console.error(error);
      } finally {
        this.stopLoading();
      }
    }
  },
  mounted () {
    this.startLoading();

    this.setupStripe();
    this.getSetupIntent();

    this.stopLoading();
  }
}
</script>
<style>
  #card-element {
    padding: 10px;
    margin: 10px 0;
  }
</style>
